import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-mx-16 flex flex-col overflow-y-auto px-16 py-8 tablet:-mx-24 tablet:px-24"
}
const _hoisted_2 = {
  key: 1,
  class: "center-center absolute text-center"
}
const _hoisted_3 = { class: "text-16" }
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cart_drawer_kit_item = _resolveComponent("cart-drawer-kit-item")
  const _component_cart_drawer_item = _resolveComponent("cart-drawer-item")

  return ($props.cartHasItems)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "above_products"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.kitItems, (item) => {
          return (_openBlock(), _createBlock(_component_cart_drawer_kit_item, {
            key: item.key,
            item: item
          }, null, 8, ["item"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
          return (_openBlock(), _createBlock(_component_cart_drawer_item, {
            key: item.key,
            item: item
          }, null, 8, ["item"]))
        }), 128)),
        _renderSlot(_ctx.$slots, "below_products")
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.locale.cart_empty), 1),
        ($props.emptyCartRedirectUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: $props.emptyCartRedirectUrl,
              class: "btn btn-primary btn-small mt-16"
            }, _toDisplayString($props.locale.cart_shop_now), 9, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
}